module.exports = __webpack_public_path__ + "img/ico-info.31a6afcb.png";